<script>
    // ALFX_FUTURE: More fine-grained options to show/hide assets: Hydrants, Valves, Other
    import { allInfrastructures, allCategories } from "../scripts/wpn2Model.js";
    import mapPrefs from "../Stores/mapPreferencesStore.js";
    import ModalTitle from "./Modal/ModalTitle.svelte";
    import ModalButtons from "./Modal/ModalButtons.svelte";

    let actionButtons = ["close", "default"];
    let firstGo = true;
    let wasChanged = "none";
    let drawingMode = $mapPrefs.modeDrawPipe;
    let mapPrefsCategories = ['assets', 'nhm', 'alfx-heat-map'];

    function changeInfrastructure(event) {
        var infra = event.target.id;
        var modifiedInfras = $mapPrefs.infrastructures.filter(
            (x) => x != infra
        );
        if (event.target.checked) {
            modifiedInfras.push(infra);
        }
        mapPrefs.updateInfrastructures(modifiedInfras);
        noteChange(event.target.id);
    }

    function changeCategory(event) {
        var cat = event.target.id;
        var modifiedCats = $mapPrefs.categories.filter((x) => x != cat);
        if (event.target.checked) {
            modifiedCats.push(cat);
        }
        mapPrefs.updateCategories(modifiedCats);
        noteChange(event.target.id);
    }

    function changeServicesVisibility(event) {
        const mode = (event.target.checked) ? "on" : "off";
        mapPrefs.updateModeShowServices(mode);
        noteChange(event.target.id);
    }

    function changePipeDrawingMode(event) {
        mapPrefs.updateModeDrawPipe(event.target.value);
        noteChange(event.target.value);
    }

    function setToDefault() {
        mapPrefs.setDefault();
        drawingMode = $mapPrefs.modeDrawPipe;
        noteChange("default");
    }

    function noteChange(cType) {
        firstGo = false;
        wasChanged = cType;
    }
</script>

<div>
    <ModalTitle title="Map Preferences" on:close />
</div>
{#if wasChanged != "none" || firstGo}
    <section class="cards">
        <div class="card-view infra-card">
            <h3 class="card-heading">Show Infrastructures</h3>
            {#each allInfrastructures() as infra}
                <div class="color-box-option" id={infra.tag}>
                    <label class="prefs-checkbox-label">
                        <input
                            class="select-check"
                            type="checkbox"
                            checked={$mapPrefs.infrastructures.includes(infra.value)}
                            id={infra.value}
                            on:input={changeInfrastructure}
                        />
                        <span>{infra.title}</span>
                    </label>
                </div>
            {/each}
        </div>
        <div class="card-view cat-card">
            <h3 class="card-heading">Show Features</h3>
            {#each mapPrefsCategories as catName}
                <div class="color-box-option" id={allCategories().find((x) => x.name === catName).tag}>
                    <label class="prefs-checkbox-label">
                        <input
                            class="select-check"
                            type="checkbox"
                            checked={$mapPrefs.categories.includes(catName)}
                            id={catName}
                            on:input={changeCategory}
                        />
                        <span>{allCategories().find((x) => x.name === catName).title}</span>
                    </label>
                </div>
            {/each}
            {#if $mapPrefs.categories.includes("assets")}
            <!-- {#if 1} -->
                <div class="show-services-option">
                    <label class="show-services-checkbox-label">
                        <input
                            class="select-check"
                            type="checkbox"
                            checked={$mapPrefs.showServices === "on"}
                            id="show-services"
                            on:input={changeServicesVisibility}
                        />
                        <span>Show Services</span>
                    </label>
                </div>
            {/if}
        </div>
        <div class="card-view pd-card">
            <h3 class="card-heading">Pipe Appearance</h3>
            {#each mapPrefs.allPipeDrawingModes() as pm}
                <label>
                    <input
                        type="radio"
                        bind:group={drawingMode}
                        value={pm.mode}
                        id={pm.index}
                        on:input={changePipeDrawingMode}
                    />
                    {pm.title}
                </label>
            {/each}
            <div id="pipe-colors">
                {#each mapPrefs.valuesForPipeDrawingMode(drawingMode) as item}
                    <div class="color-band">
                        <div
                            class="pipe-band"
                            style="background-color:{item.color}"
                        />
                        <div class="pipe-color-label">{item.title}</div>
                    </div>
                {/each}
            </div>
        </div>
    </section>
{/if}
<footer>
    <slot name="footer">
        <ModalButtons
            actions={actionButtons}
            on:close
            on:default={setToDefault}
        />
    </slot>
</footer>

<style>
    :global(.cards) {
        background-color: white;
        padding: 0;
        margin: 0;
        height: 70vh;
    }
    :global(.card-view) {
        position: absolute;
        display: inline-block;
        min-height: 48vh;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
        border-radius: 5px;
        background: white;
        margin: 0;
        padding: 0.5rem;
        width: 20%;
    }
    :global(h3) {
        color: rgb(67, 148, 11);
        font-size: large;
        font-weight: 300;
        text-align: center;
    }
    .card-heading {
        margin: 8px auto 32px 0;
    }
    .prefs-checkbox-label {
        display: block;
    }
    .show-services-checkbox-label {
        display: block;
    }
    .show-services-option {
        display: flex;
        margin-top: 2rem;
    }
    input[type="radio"] {
        margin: 3px 3px 8px 8px;
        cursor: pointer;
    }
    input[type="checkbox"] {
        position: relative;
        cursor: pointer;
    }
    input[type="checkbox"]:before {
        display: block;
        position: absolute;
        width: 10px;
        height: 10px;
        top: 0;
        left: 0;
        border: 2px solid #777777;
        border-radius: 3px;
        background-color: white;
    }
    input[type="checkbox"]:checked:after {
        display: block;
        width: 5px;
        height: 10px;
        border: solid #777777;
        border-width: 0 2px 2px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
        position: absolute;
        top: 2px;
        left: 6px;
    }
    .color-box-option label {
       display: inline-block;
        padding-right: 10px;
        white-space: nowrap;
    }
    .color-box-option input {
        vertical-align: middle;
    }
    .color-box-option label span {
        vertical-align: middle;
    }

    .select-check {
        margin: 0;
    }
    .color-box-option {
        margin: 12px;
        padding: 8px 8px;
        border-radius: 4px;
    }
    #water {
        border: 1px solid #007aff;
        border-left: 8px solid #007aff;
    }
    #electric {
        border: 1px solid #ff4b4b;
        border-left: 8px solid #ff4b4b;
    }
    #gas {
        border: 1px solid #ffcc00;
        border-left: 8px solid #ffcc00;
    }
    #storm {
        border: 1px solid #58cafb;
        border-left: 8px solid #58cafb;
    }
    #streets {
        border: 1px solid #996633;
        border-left: 8px solid #996633;
    }
    #waste {
        border: 1px solid #4cd964;
        border-left: 8px solid #4cd964;
    }
    #assets, #nhm, #alfx-heat-map {
        border: 1px solid gray;
        border-left: 8px solid lightgray;
    }
    .infra-card {
        left: 10%;
    }
    .cat-card {
        left: calc(40%);
    }
    .pd-card {
        left: calc(70%);
    }

    #pipe-colors {
        padding: 8px;
        margin: 8px auto;
    }
    .color-band {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        margin: auto;
    }
    .pipe-band {
        width: 16px;
        height: 2px;
        padding-left: 32px;
    }
    .pipe-color-label {
        padding: 2px 8px;
    }

    @media (max-width: 768px) {
        .cards {
            overflow-y: scroll;
        }
        .card-view {
            position: static;
            display: block;
            width: 50%;
            margin: 1rem auto;
        }
    }
</style>
